<div class="cm-admin-page bk-clearfix">
    <div class="bk-nav__title-container">
        <h4 class="bk-nav__title">{{'Administration' | translate }} <span *ngIf="title">/ {{ title }}</span></h4>
    </div>
    <ul class="cm-admin-nav bk-clearfix">

		<li class="cm-admin-nav__item"
			routerLink="/cropStages"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="0"
			role="link">
			Crop Stages
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/CropTypes"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="1">
			Crop Types
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/fertilizers"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="3">
			Fertilizers
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/flowmeter"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="4">
			Flow Meter Data
		</li>
		<li class="cm-admin-nav__item"
			routerLink="/GlobalSettings"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="5">
			Global Settings
		</li>
		<li class="cm-admin-nav__item"
			routerLink="/IgnoreSchedules"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="6">
			Ignore schedules
		</li>
		<li class="cm-admin-nav__item"
			routerLink="/Localization"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="7">
			Localization
		</li>
		<li class="cm-admin-nav__item"
			routerLink="/Ranches"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="8">
			Ranches
		</li>
		<li class="cm-admin-nav__item"
			routerLink="/SoilSensor"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="9">
			Soil Sensors
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/statistics"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="10">
			Statistics
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/userManagement"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="11">
			User Management
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/WeatherStations"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="12">
			Weather Stations
		</li>

		<li class="cm-admin-nav__item"
			routerLink="/WebAPIStatistics"
			[routerLinkActive]="'cm-admin-nav__item--selected'"
			tabindex="13">
			Web API Statistics
		</li>
    </ul>
</div>
<ng-content></ng-content>
